import React, { useEffect } from 'react';
import FormSteps from '../FormSteps';

interface CalendlyStepProps {
    goToNextStep: () => void;
    skipStep: () => void;
}

const CalendlyStep: React.FC<CalendlyStepProps> = ({ goToNextStep, skipStep }) => {
    useEffect(() => {
        const existingScript = document.querySelector('script[src="https://assets.calendly.com/assets/external/widget.js"]');

        if (!existingScript) {
            const script = document.createElement('script');
            script.src = 'https://assets.calendly.com/assets/external/widget.js';
            script.async = true;
            document.body.appendChild(script);

            return () => {
                if (document.body.contains(script)) {
                    document.body.removeChild(script);
                }
            };
        }
    }, []);

    return (
        <FormSteps
            header="Schedule a Welcome Call"
            description="Let's schedule a quick call to help you get started. You can also skip this and explore on your own."
            nextButton={goToNextStep}
            skipButton={skipStep}
            nextButtonText="Next"
        >
            <div
                className="calendly-inline-widget"
                data-url="https://calendly.com/soraya_u/30min?text_color=5775ff&primary_color=5775ff"
            />
        </FormSteps>
    );
};

export default CalendlyStep;